export default __webpack_public_path__ + "fc7f9818465a6c0b25c8f4b380f8490f.jpeg";